import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/search/search.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/acq/AdvertiseMiniLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ads/paid/paid-ads.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ads/paid/PaidAdClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ds/e/FooterTalkLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds/e/HeaderAuth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ds/e/SegmentTabs.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds2/CardImg.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds2/ds2.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/search/KdSearchBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/search/PopularRegionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/search/SearchConfirmLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchMissCta"] */ "/vercel/path0/src/components/search/SuggestSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/thumb/Thumb.tsx");
